import styled from 'styled-components'
import {SelectItem, SelectTrigger} from '@/components/ui/select-atoms/SelectAtoms'

export const StyledSelectItem = styled(SelectItem)`
    text-transform: capitalize;
`

export const StyledSelectTrigger = styled(SelectTrigger)`
    text-transform: capitalize;
`
